import React from 'react';
import { ContentBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';

const PollNotActive = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className="news-detail-page-container add-icons-to-file-anchors">
      <ContentBlock
        contentVisible
        blockWrapper="block-wrapper"
        contentWrapper="content-wrapper"
        shadow
        title={data !== undefined ? data.name : t('Anketa nie je aktívna')}
      >
        <>
          {data === undefined ? t('Anketa nie je aktívna.') : ''}
          {t('Do ankety sa budete môcť zapojiť, keď bude aktívna.')}
        </>
      </ContentBlock>
    </div>
  );
};
export default PollNotActive;
